//define events
export const TelemetryEvents = {
    navigation: {
        menu_extra_services: 'navigation.extra_services.open'
        //  menu_open: 'navigation.menu.open',
        // menu_close: 'navigation.menu.close',
        // tab_change: 'navigation.tab.change'
    },
    ui: {
        // button_click: 'ui.button.click',
        //dropdown_select: 'ui.dropdown.select',
        // toggle_switch: 'ui.toggle.switch'
        pinned_menu_item: 'ui.menu_item.pinned'
    },
    modal: {
        create_dashboard_opened: 'modal.create_dashboard.open'
        //open: 'modal.open',
        //close: 'modal.close'
    },
    form: {
    // submit: 'form.submit',
    //error: 'form.error'
    },
    feature: {
        // export_csv: 'feature.export.csv',
        //export_pdf: 'feature.export.pdf',
        download_manual: 'feature.manual.download',
        download_manual_in_protocol: 'feature.manual.download_in_protocol',
        old_pdf_report: 'feature.old_report_export.export',
        hide_logger: 'feature.visibility.hide_logger',
        change_visibility_for_all_loggers: 'feature.visibility.change_for_all_loggers'
    }
};
//define error types
export var TelemetryErrorTypes;
(function (TelemetryErrorTypes) {
    TelemetryErrorTypes["NETWORK"] = "network";
})(TelemetryErrorTypes || (TelemetryErrorTypes = {}));
